import { isObserverSupported } from "helpers/isObserverSupported";

const sharedObservers = {
	_intersectionObserver: null,
	_resizeObserver: null,
	_intersectionCallbacks: new Map(),
	_resizeCallbacks: new Map(),

	getIntersectionObserver() {
		if (
			!this._intersectionObserver &&
			isObserverSupported("IntersectionObserver")
		) {
			this._intersectionObserver = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						const callback = this._intersectionCallbacks.get(
							entry.target,
						);
						if (callback) {
							callback(entry.isIntersecting);
						}
					});
				},
				{
					threshold: 0,
					rootMargin: "100px 0px 100px 0px",
				},
			);
		}
		return this._intersectionObserver;
	},

	getResizeObserver() {
		if (!this._resizeObserver && isObserverSupported("ResizeObserver")) {
			this._resizeObserver = new ResizeObserver((entries) => {
				entries.forEach((entry) => {
					const callback = this._resizeCallbacks.get(entry.target);
					if (callback) {
						callback(entry.contentRect.height);
					}
				});
			});
		}
		return this._resizeObserver;
	},

	observeIntersection(element, callback) {
		if (!element || !isObserverSupported("IntersectionObserver")) {
			return () => {};
		}

		this._intersectionCallbacks.set(element, callback);
		const observer = this.getIntersectionObserver();

		if (observer) {
			try {
				observer.observe(element);
			} catch (error) {
				// ** Ignore errors when observing element
			}
		}

		return () => {
			this._intersectionCallbacks.delete(element);
			if (observer) {
				try {
					observer.unobserve(element);
				} catch (error) {
					// ** Ignore errors during cleanup
				}
			}
		};
	},

	observeResize(element, callback) {
		if (!element) {
			return () => {};
		}

		this._resizeCallbacks.set(element, callback);
		const observer = this.getResizeObserver();

		if (observer) {
			try {
				observer.observe(element);
			} catch (error) {
				// ** Ignore errors when observing element
			}
		}

		return () => {
			this._resizeCallbacks.delete(element);
			if (observer) {
				try {
					observer.unobserve(element);
				} catch (error) {
					// ** Ignore errors during cleanup
				}
			}
		};
	},
};

export default sharedObservers;
